import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    option_type_id: data?.option_type?.id,
    enOptionValue: data?.localized_data?.en.name,
    arOptionValue: data?.localized_data?.ar.name,
    presentation:
      data?.option_type?.name === "color" || data?.option_type?.name === "Color"
        ? data?.presentation
        : "",
    image: data?.image,
    ...data?.localized_data,
  };
};

export const structure = (
  optionsTypes,
  optionType,
  optionTypesOptions,
  details,
  t
) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "file",
        label: t("products_option_values.image"),
        width: "100%",
      },
      {
        name: `option_type_id`,
        kind: "select",
        type: "text",
        label: `${t("products_option_values.option_type")}*`,
        width: "47%",
        placeholder: t("products_option_values.choose_option_type"),
        // options:optionsTypes
        ...optionTypesOptions?.optionTypes,
      },
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("products_option_values.option_value_en")}*`,
        width: "47%",
        placeholder: t("products_option_values.write_option_value_en"),
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: `${t("products_option_values.option_value_ar")}*`,
        width: "47%",
        placeholder: t("products_option_values.write_option_value_ar"),
        display: "none",
      },
      optionType?.toLowerCase() === "color" && {
        name: `presentation`,
        kind: "colorInut",
        type: "text",
        label: `${t("products_option_values.pick_color")}*`,
        width: "47%",
        placeholder: t("products_option_values.pick_color_placeholder"),
        disabled: !optionType && true,
      },
    ],
  },
];

export const validationSchema = (optionType, t) =>
  Yup.object({
    option_type_id: Yup.string().required(t("common.required")),
    en: Yup.object().shape({
      name: Yup.string().required(t("common.required")),
    }),
    ar: Yup.object().shape({
      name: Yup.string().required(t("common.required")),
    }),
    presentation:
      (optionType === "color" || optionType === "Color") &&
      Yup.string().required(t("common.required")),
    // image: Yup.mixed(),
  });
